import { VariableNames } from "../../../../UserInterfaceModule/Constants/VariableNames";
import { CollectionMapExpression } from "../../../Models/Collections/CollectionMapExpression";
import { IExpressionEvaluator, IHasExpressionMetadata } from "../../../Models/IExpressionEvaluator";
import { MaybePromise } from "../../../Models/MaybePromise";
import { IExpressionEvaluatorContext } from "../../../Models/IExpressionEvaluatorContext";

export class CollectionMapExpressionEvaluator implements IExpressionEvaluator<CollectionMapExpression>, IHasExpressionMetadata {
    private static _expressionPropertyNames: string[] = ["Collection", "Map"];

    get expressionProperties(): string[] {
        return CollectionMapExpressionEvaluator._expressionPropertyNames;
    }

    get type(): string {
        return "CollectionMap";
    }

    evaluate(expression: CollectionMapExpression, context: IExpressionEvaluatorContext): MaybePromise {
        const collection = context.Evaluator.evaluate(expression.Collection, context);

        if (collection instanceof Promise) {
            return collection.then((resolvedCollection) => this.mapCollection(resolvedCollection, expression, context));
        }

        return this.mapCollection(collection, expression, context);
    }

    private mapCollection(collection: any[], expression: CollectionMapExpression, context: IExpressionEvaluatorContext): MaybePromise {
        if (!Array.isArray(collection)) {
            return [];
        }

        const mapResults: any[] = [];
        let hasPromise = false;

        const childContext = context.CreateChild();
        for (const item of collection) {
            childContext.VariableScope.set(VariableNames.Item, item);

            const mapResult = context.Evaluator.evaluate(expression.Map, childContext);
            mapResults.push(mapResult);
            if (mapResult instanceof Promise) {
                hasPromise = true;
            }
        }

        if (hasPromise) {
            return Promise.all(mapResults);
        }

        return mapResults;
    }
}
